module.exports = ".version-p{margin:2rem 2rem}\n"